import React from "react";
import {
  ProductModalContainer,
  CorouselContainer,
  ImageContainer,
  CloseButton,
  CloseRight,
  CloseLeft,
  Corouselresponsive,
  WebImageContainer,
  WebCorouselresponsive,
} from "./project_modal_components";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

const ProductModal = ({ onTap, data }) => {
  return (
    <ProductModalContainer>
      <CloseButton onClick={onTap}>
        <CloseRight>
          <CloseLeft></CloseLeft>
        </CloseRight>
      </CloseButton>
      <h2>{data.name}</h2>
      <h3>{data.desc}</h3>
      <h4>{data.platform}</h4>
      <CorouselContainer>
        <Carousel
          ssr
          // infinite
          containerClass="container-with-dots"
          itemClass="image-item"
          responsive={data.isweb ? WebCorouselresponsive : Corouselresponsive}
        >
          {data.snaps.map((snap, i) => {
            return (
              <Zoom key={i}>
                {data.isweb ? (
                  <WebImageContainer
                    src={require("../../../assets/images/" + snap.img)}
                    alt={data.name}
                  ></WebImageContainer>
                ) : (
                  <ImageContainer
                    src={require("../../../assets/images/" + snap.img)}
                    alt={data.name}
                  ></ImageContainer>
                )}
              </Zoom>
            );
          })}
        </Carousel>
      </CorouselContainer>
    </ProductModalContainer>
  );
};

export default ProductModal;
